import Component from '../abstracts/Component';
import vex from 'vex-js';

export default class SizeGuideComponent extends Component {
  get COMPONENTNAME() {
    return 'SizeGuideComponent';
  }

  constructor(compEl) {
    super(compEl);
    this.sizeGuideTriggerList = this.$component.querySelectorAll(this.SELECTORS.sizeGuideTrigger);
  }

  get SELECTORS() {
    return {
      sizeGuideTrigger: "[data-js-size-guide]",
    };
  }

  // handle size guide open //
  handleSizeGuide() {
    const self = this;
    if (this.sizeGuideTriggerList.length > 0) {
      this.sizeGuideTriggerList.forEach((sizeGuideTrigger) => {
        sizeGuideTrigger.addEventListener("click", (event) => {
          event.preventDefault();
          sizeGuideTrigger.setAttribute('disabled', '');
          fetch(sizeGuideTrigger.href)
            .then(response => response.text())
            .then(text => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(text, "text/html");
              const sizeGuide = doc.querySelector('[data-ajax-chunk]');
              vex.open({
                unsafeContent: sizeGuide,
                closeClassName: 'icon-close',
                className: 'size-guide',
                showCloseButton: true,
                afterOpen: function () {
                  this.closeEl.classList.remove('vex-close');
                  self.importComponents("CollapseComponent")
                    .then(({default: module}) => {
                      const component = new module(sizeGuide);
                      component.render();
                    })
                    .catch(error => {
                      console.error("Failed to load the component", error.stack);
                    });
                },
                afterClose: function () {
                  sizeGuideTrigger.removeAttribute('disabled');
                }
              });
            })
            .catch(error => console.error(error));
        });
      });
    }
  }

  importComponents(componentName) {
    return import(`../components/${componentName}`);
  }

  bindEvents() {
    this.handleSizeGuide();
  }

  render() {
    super.render();
    this.bindEvents();
  }
}
